import { Action, createReducer, on } from '@ngrx/store';
import { IToDoResponse } from '../../todos/models/todos.model';
import { ISearchExistingUserLegalEntitySetup } from '../models/search-existing-user.model';
import * as actions from '../actions';

export const searchExitingUserLegalEntitySetupFeatureKey = 'searchExitingUserLegalEntitySetup';

export interface SearchExitingUserLegalEntitySetupState {
  loadSearchExitingUsers: ISearchExistingUserLegalEntitySetup;
  loadSearchExistingUsersResponse: IToDoResponse;
}

export const initialState: SearchExitingUserLegalEntitySetupState = {
  loadSearchExitingUsers: undefined,
  loadSearchExistingUsersResponse: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadSearchExistingUsers, (state, action) => ({
    ...state,
    loadSearchExitingUsers: action.request
  })),
  on(actions.loadSearchExistingUsersSuccess, (state, action) => ({
    ...state,
    loadSearchExistingUsersResponse: action.response
  }))
);

export const getSearchExistingUsersResponse = (state: SearchExitingUserLegalEntitySetupState) => state.loadSearchExistingUsersResponse;
